
import React, { createContext, useContext, ReactNode } from 'react';
import useDemoData from '@/hooks/useDemoData';

interface DemoDataContextType {
  isDemoMode: boolean;
  demoClients: any[];
  demoProjects: any[];
  demoInvoices: any[];
  demoTimeEntries: any[];
}

// Create context with a default undefined value
const DemoDataContext = createContext<DemoDataContextType | undefined>(undefined);

// The provider component that will wrap the app
export const DemoDataProvider = ({ children }: { children: ReactNode }) => {
  const demoData = useDemoData();
  
  return (
    <DemoDataContext.Provider value={demoData}>
      {children}
    </DemoDataContext.Provider>
  );
};

// Custom hook to use the demo data context
export const useDemoDataContext = () => {
  const context = useContext(DemoDataContext);
  if (context === undefined) {
    throw new Error('useDemoDataContext must be used within a DemoDataProvider');
  }
  return context;
};
